import React, { useState } from 'react'
import axios from 'axios';

import { Grid, Stack, Typography, Box, FormControl, Select, MenuItem, InputLabel } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';

import InputFieldComponent from '../../components/inputFields/InputFieldComponent';
import IconButton from '../../components/buttons/IconButton';
import Snackbar from '../../components/snackbar/Snackbar';
import Loader from '../../components/loader/Loader';
import DialogComponent from '../../components/dialogComponent/DialogComponent'


function Form() {

    const prod = 'https://api.ritzmotoclub.com/' // This is the new production domain  'https://rmc-api-phinahas-projects-41da129b.vercel.app/';
    const local = 'http://localhost:8080/';//THis is only for local testing


    const [loading, setLoading] = useState(false);
    const [dialogState, setDialogState] = useState(false);
    const [dialogMessage, setDialogMessage] = useState('');
    const [dialogSubtitle, setDialogSubtitle] = useState('');
    const [showWhatsappLink, setShowWhatsappLink] = useState(false);

    const [snackbarState, setSnackbarState] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('Testing alerts');
    const [snackbarServity, setSnackbarServity] = useState('info');

    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [registrationNumber, setRegistrationNumber] = useState('');
    const [variant, setVariant] = useState('');
    const [phoneCountryCode, setPhoneCountryCode] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [whatsappNumberCountryCode, setWhatsappNumberCountryCode] = useState('');
    const [whatsappNumber, setWhatsappNumber] = useState('');
    const [address, setAddress] = useState('');
    const [postOffice, setPostOffice] = useState('');
    const [district, setDistrict] = useState('');
    const [state, setState] = useState('');
    const [pincode, setPincode] = useState('');


    const changeSnackbarState = () => {
        setSnackbarState(false);
    };

    const changeDialogState = () => {
        setDialogState(false);
        window.location.reload();
    };





    const formSubmit = () => {
        try {

            //console.log(name, email, address, phoneNumber, whatsappNumber, address, pincode);

            if (!name || name.length < 2 || 
                !email || email.length < 3 || 
                !phoneNumber || 
                // phoneCountryCode.length < 2 || 
                // !phoneCountryCode ||
                !whatsappNumber || 
                // whatsappNumberCountryCode.length < 2 || 
                // !whatsappNumberCountryCode || 
                !address || address.length < 2 || 
                postOffice.length < 2 || !postOffice ||
                district.length < 2 || !district || 
                state.length < 2 || !state || 
                pincode.length < 2 || !pincode
            ) {
                setSnackbarMessage("Some required data is missing");
                setSnackbarServity('error');
                setSnackbarState(true);

                return;
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!emailRegex.test(email.trim())) {
                setSnackbarMessage("Please enter a valid email address");
                setSnackbarServity("error");
                setSnackbarState(true);
                return;
            }

            const phoneRegex = /^[0-9]{10,15}$/;

            if (!phoneRegex.test(phoneNumber.trim())) {
                setSnackbarMessage("Please enter a valid phone number");
                setSnackbarServity("error");
                setSnackbarState(true);
                return;
            }

            if (!phoneRegex.test(whatsappNumber.trim())) {
                setSnackbarMessage("Please enter a valid WhatsApp number");
                setSnackbarServity("error");
                setSnackbarState(true);
                return;
            }

            if (!Number(phoneNumber) || !Number(whatsappNumber) || 
            // !Number(whatsappNumberCountryCode) || !Number(phoneCountryCode) || 
            !Number(pincode)) {
                setSnackbarMessage("Something wrong with the number fields, check phone number or pincode fields");
                setSnackbarServity('error');
                setSnackbarState(true);

                return;
            }

            // if (phoneNumber.length !== 10 || whatsappNumber.length !== 10) {
            //     setSnackbarMessage("check your given numbers length");
            //     setSnackbarServity('error');
            //     setSnackbarState(true);

            //     return;
            // }

            setLoading(true);
            axios.post(`${prod}v1/user/auth/form-signup`, { name: name, email: email, phoneNumber: phoneNumber, whatsappNumber: whatsappNumber, address: address, pincode: pincode, phoneCountryCode: phoneCountryCode, whatsappNumberCountryCode: whatsappNumberCountryCode, postOffice: postOffice, district: district, state: state, registrationNumber: registrationNumber.toUpperCase(), variant: variant }).then((response) => {

                setLoading(false);
                setDialogMessage("Registration Submitted");
                setShowWhatsappLink(false);
                setDialogSubtitle(
                    `Hi ${name}, thank you for applying to join RitzMotoClub.

                    Your membership request has been submitted successfully and is currently being reviewed by our team. We will notify you as soon as your application has been approved via mail.
                    `
                );

                setDialogState(true);
                // setSnackbarMessage(response.data.message);
                // setSnackbarServity('success');
                // setSnackbarState(true);

                return;


            }).catch((error) => {

                //console.log(error);
                setLoading(false);
                setDialogMessage("Message from Admin");
                setShowWhatsappLink(true);
                setDialogSubtitle(
                    `Hi ${name}, your application has been received successfully. Our administrators are currently reviewing the submitted information.

                    You will be contacted shortly regarding approval and membership onboarding.`
                );

                setDialogState(true);


                return;
            })





        } catch (error) {
            //console.log(error)
            setLoading(false);
            setSnackbarMessage(error.message);
            setSnackbarServity('error');
            setSnackbarState(true);
            return;
        }
    }




    return (
        <>
            <Snackbar
                message={snackbarMessage}
                openStatus={snackbarState}
                severity={snackbarServity}
                onCloseFunction={changeSnackbarState}
            />

            <DialogComponent
                openState={dialogState}
                onChangeOpenState={changeDialogState}
                caption={dialogSubtitle}
                message={dialogMessage}
                showWhatsappLink={showWhatsappLink}
            />

            <Loader openState={loading} />

            <Box
                sx={{
                    minHeight: "100vh",
                    background:
                        "radial-gradient(circle at 10% 20%, #0a0c12, #030507)",
                    py: 5,
                    px: 2,
                }}
            >
                <Box
                    sx={{
                        maxWidth: "900px",
                        mx: "auto",
                        overflow: "hidden",
                        borderRadius: "40px",
                        background:
                            "radial-gradient(ellipse at 20% 30%, #191e26, #0a0c10)",
                        border: "1px solid rgba(230,57,70,0.3)",
                        boxShadow: "0 30px 50px rgba(0,0,0,0.7)",
                    }}
                >
                    {/* HEADER */}

                    <Box
                        sx={{
                            textAlign: "center",
                            py: 5,
                            px: 3,
                            background:
                                "linear-gradient(135deg,#1e232e 0%,#0f131a 100%)",
                            borderBottom: "2px solid #e63946",
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: {
                                    xs: "2rem",
                                    md: "3rem",
                                },
                                fontWeight: 800,
                                letterSpacing: 2,
                                background:
                                    "linear-gradient(135deg,#fff,#e63946,#ffb347)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                            }}
                        >
                            RITZMOTOCLUB
                        </Typography>

                        <Box
                            sx={{
                                display: "inline-flex",
                                mt: 2,
                                px: 3,
                                py: 1,
                                borderRadius: "999px",
                                background:
                                    "linear-gradient(145deg,#e63946,#a61e2c)",
                                color: "#fff",
                                fontWeight: 700,
                                fontSize: "12px",
                            }}
                        >
                            ✦ MEMBERSHIP REGISTRATION ✦
                        </Box>

                        <Typography
                            variant="h4"
                            sx={{
                                color: "#fff",
                                mt: 3,
                                fontWeight: 700,
                            }}
                        >
                            Join The Elite Circle
                        </Typography>

                        <Typography
                            sx={{
                                color: "#b9c7d9",
                                mt: 1,
                            }}
                        >
                            Fill in your details to become a full member of the ultimate
                            Maruti Ritz community
                        </Typography>
                    </Box>

                    {/* FORM */}

                    <Box sx={{ p: { xs: 3, md: 5 } }}>
                        <Grid container spacing={3}>
                            {/* LEFT */}

                            <Grid item xs={12} md={6}>
                                <InputFieldComponent
                                    label="Full Name"
                                    required
                                    value={name}
                                    onChangeFn={setName}
                                    placeholder="e.g., John Doe"
                                />

                                <Box mt={3}>
                                    <InputFieldComponent
                                        label="Email Address"
                                        type="email"
                                        required
                                        value={email}
                                        onChangeFn={setEmail}
                                        placeholder="e.g., example@gmail.com"
                                    />
                                </Box>

                                <Box mt={3}>
                                    <InputFieldComponent
                                        label="Registration Number"
                                        required
                                        value={registrationNumber}
                                        onChangeFn={setRegistrationNumber}
                                        placeholder="e.g., KL08AA1111"
                                    />
                                </Box>

                                <Box mt={3}>
                                    <FormControl fullWidth>
                                        <Typography
                                            sx={{
                                                mb: 1,
                                                fontSize: "13px",
                                                fontWeight: 700,
                                                letterSpacing: "1px",
                                                textTransform: "uppercase",
                                                color: "#e63946",
                                            }}
                                        >
                                            Variant <span style={{ color: "#ff8c42" }}>*</span>
                                        </Typography>

                                        <Select
                                            fullWidth
                                            displayEmpty
                                            value={variant}
                                            onChange={(e) => setVariant(e.target.value)}
                                            MenuProps={{
                                                PaperProps: {
                                                    sx: {
                                                        bgcolor: "#0f141c",
                                                        color: "#fff",
                                                        border: "1px solid rgba(230,57,70,0.3)",
                                                        borderRadius: "12px",

                                                        "& .MuiMenuItem-root:hover": {
                                                            backgroundColor: "rgba(230,57,70,0.15)",
                                                        },

                                                        "& .Mui-selected": {
                                                            backgroundColor: "rgba(230,57,70,0.2) !important",
                                                        },
                                                    },
                                                },
                                            }}
                                            renderValue={(selected) => {
                                                if (!selected) {
                                                    return (
                                                        <span style={{ color: "#949191", fontWeight: 400 }}>
                                                            Select Variant
                                                        </span>
                                                    );
                                                }
                                                return selected;
                                            }}
                                            sx={{
                                                borderRadius: "20px",
                                                background: "rgba(15,20,28,0.85)",
                                                color: "#fff",
                                                fontWeight: 600,

                                                "& .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: "#8B1E2D", // dark red
                                                },

                                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: "#E63946", // bright red
                                                },

                                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                    borderColor: "#E63946",
                                                    borderWidth: "2px",
                                                },

                                                "& .MuiSvgIcon-root": {
                                                    color: "#E63946",
                                                },

                                                "& .MuiSelect-select": {
                                                    color: "#fff",
                                                    padding: "14px 18px",
                                                },
                                            }}
                                        >
                                            <MenuItem value="" disabled>
                                                Select Variant
                                            </MenuItem>

                                            {["LXi", "VXi", "ZXi", "LDi", "VDi", "ZDi"].map((item) => (
                                                <MenuItem key={item} value={item}>
                                                    {item}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>

                                <Box mt={3}>
                                    <InputFieldComponent
                                        label="Phone Number (with country code)"
                                        required
                                        value={phoneNumber}
                                        onChangeFn={setPhoneNumber}
                                        placeholder="e.g., 91 9847404040"
                                    />
                                </Box>

                                <Box mt={3}>
                                    <InputFieldComponent
                                        label="Whatsapp Number (with country code)"
                                        required
                                        value={whatsappNumber}
                                        onChangeFn={setWhatsappNumber}
                                        placeholder="e.g., 91 9847404040"
                                    />
                                </Box>
                            </Grid>

                            {/* RIGHT */}

                            <Grid item xs={12} md={6}>
                                <Box mt={0}>
                                    <InputFieldComponent
                                        label="Address"
                                        placeholder="House Number, Street, Area"
                                        multiline
                                        rows={5.56}
                                        value={address}
                                        onChangeFn={setAddress}
                                        required
                                    />
                                </Box>

                                <Box mt={3}>
                                    <InputFieldComponent
                                        label="Post Office"
                                        required
                                        value={postOffice}
                                        onChangeFn={setPostOffice}
                                        placeholder="e.g., MG Road"
                                    />
                                </Box>

                                <Box mt={3}>
                                    <InputFieldComponent
                                        label="District"
                                        required
                                        value={district}
                                        onChangeFn={setDistrict}
                                        placeholder="e.g., Thiruvananthapuram"
                                    />
                                </Box>

                                <Box mt={3}>
                                    <InputFieldComponent
                                        label="State"
                                        required
                                        value={state}
                                        onChangeFn={setState}
                                        placeholder="e.g., Kerala"
                                    />
                                </Box>

                                <Box mt={3}>
                                    <InputFieldComponent
                                        label="Pincode"
                                        required
                                        value={pincode}
                                        onChangeFn={setPincode}
                                        placeholder="e.g., 695001"
                                    />
                                </Box>
                            </Grid>

                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        mt: 3,
                                        mb: 2,
                                        height: "2px",
                                        background:
                                            "linear-gradient(90deg,#e63946,#ffb347,#e63946)",
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Typography
                                    align="center"
                                    sx={{
                                        color: "#e63946",
                                        fontWeight: 600,
                                    }}
                                >
                                    🔒 All fields are mandatory & will be verified by the
                                    club team.
                                </Typography>
                            </Grid>

                            <Grid item xs={12}>
                                <Box
                                    component="button"
                                    onClick={formSubmit}
                                    sx={{
                                        width: "100%",
                                        border: "none",
                                        cursor: "pointer",
                                        py: 2,
                                        color: "#fff",
                                        fontSize: "18px",
                                        fontWeight: 700,
                                        borderRadius: "999px",
                                        background:
                                            "linear-gradient(105deg,#e63946,#b91c2c)",
                                        boxShadow:
                                            "0 12px 20px -8px rgba(230,57,70,0.5)",

                                        "&:hover": {
                                            transform: "translateY(-2px)",
                                        },
                                    }}
                                >
                                    🏎️ BECOME A MEMBER →
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>

                    {/* FOOTER */}

                    <Box
                        sx={{
                            textAlign: "center",
                            background: "#05080c",
                            py: 3,
                            px: 2,
                            borderTop: "1px solid #1e2530",
                        }}
                    >
                        <Typography
                            sx={{
                                color: "#6c7e9e",
                                fontSize: "12px",
                            }}
                        >
                            © 2026 RitzMotoClub — The ultimate Maruti Ritz community
                        </Typography>

                        <Typography
                            sx={{
                                color: "#6c7e9e",
                                fontSize: "12px",
                                mt: 1,
                            }}
                        >
                            Connect with us after registration: WhatsApp group &
                            exclusive perks await.
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </>
    );
}

export default Form